import BaseClient from '@/app/model/api/response/baseApiClient'

class MachineRentDetailApi extends BaseClient {
  public getMachineRentDetail (id: string) {
    const path = '/v1/machine-rents/' + id
    const url = new URL(process.env.VUE_APP_API_URL + path)

    /* 共通処理 */
    return super.doFetch(decodeURI(url.href), 'GET')
  }
}

export default new MachineRentDetailApi()
